import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export interface GlobalNotificationModal {
  isOpen: boolean
  title: string
  description: string
  buttonText: string
  isSuccess: boolean
}

const initialState: GlobalNotificationModal = {
  isOpen: false,
  title: '',
  description: '',
  buttonText: '',
  isSuccess: false,
}

export const globalNotificationModalSlice = createSlice({
  name: 'globalNotificationModal',
  initialState,
  reducers: {
    showGlobalModal: (
      state,
      action: PayloadAction<GlobalNotificationModal>
    ) => {
      state.isOpen = true
      state.title = action.payload.title
      state.description = action.payload.description
      state.buttonText = action.payload.buttonText
      state.isSuccess = action.payload.isSuccess
    },
    hideGlobalModal: (state) => {
      state.isOpen = false
    },
  },
})

export const { showGlobalModal, hideGlobalModal } =
  globalNotificationModalSlice.actions
export default globalNotificationModalSlice.reducer
